import { RosaryBead, RosaryBeadGradients } from "./RosaryBeads";
import { rosaryRoseForStep, rosaryRosesUI } from "@/data/rosaryRoses";
import { rosaryUI } from "@/data/rosaryLocale";

export const FocusDecade = ({ controller: c }) => {
  const t = rosaryUI(c.lang);
  const roseText = rosaryRosesUI(c.lang);
  const closing = c.stepIx >= c.steps.length - 3;
  const decade = !closing && Number.isInteger(c.step.index);
  const prayers = c.steps.map((step, index) => ({ ...step, indexInSteps: index })).filter((step) => rosaryRoseForStep(step) && (decade ? step.index === c.step.index : !closing && step.anchor.startsWith("intro-")));
  const sectionName = closing ? t.closingPrayers : decade ? `${t.decade} ${c.step.index + 1}` : t.opening;
  return <figure className="focus-decade" data-testid="focus-decade">
    <figcaption data-testid="focus-decade-label">{sectionName}</figcaption>
    <svg viewBox="0 0 500 400" role="group" aria-label={`${t.diagram} · ${sectionName}`} data-testid="focus-decade-diagram">
      <defs><RosaryBeadGradients id="focus-decade" /></defs>
      {prayers.length > 0 && <ellipse cx="250" cy="200" rx="190" ry="135" fill="none" stroke="#967744" strokeWidth="2" strokeDasharray="3 3" />}
      {prayers.map((step, index) => {
        const angle = Math.PI / 2 + (index / prayers.length) * Math.PI * 2;
        const roseColour = c.prayedAnchors.has(step.anchor) ? rosaryRoseForStep(step) : null;
        return <RosaryBead key={step.anchor} x={250 + Math.cos(angle) * 190} y={200 + Math.sin(angle) * 135} anchor={step.anchor} active={c.step.anchor === step.anchor} done={Boolean(roseColour)} large={step.key === "our_father"}
          gradientId="focus-decade" contrastRoses hitRadius={29} focusRadius={27} beadRadius={step.key === "our_father" ? 20 : 16} roseSize={56} roseColour={roseColour} roseLabel={roseColour === "red" ? roseText.offeredRed : roseText.offeredWhite}
          label={step.label} testId={`focus-bead-${step.anchor}`} onSelect={() => c.navigate(step.indexInSteps)} />;
      })}
      <image href="/images/rosary/crucifix.png" x="210" y="123" width="80" height="154" preserveAspectRatio="xMidYMid meet" aria-hidden="true" data-testid="focus-decade-crucifix" />
    </svg>
  </figure>;
};